<template>
  <!-- A casca de formulário da casa: o Salvar, e o aviso de rascunho ao fechar -->
  <ontos-form-dialog v-bind="heading" max-width="720px"
                     :saving="saving" :save-disabled="!changed" :dirty="changed"
                     @save="save()" @closed="$emit('closed')">
    <ontos-colored-entry-list ref="list" editable :entries="initial" :title="$tt('roles')"
                              :create-label="$tt('role-create')" :empty-text="$tt('roles-empty')"
                              @update:entries="draft = $event"/>
  </ontos-form-dialog>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ColoredEntryList from '@/components/shared/ColoredEntryList.vue'
import {coloredRoles, WorkspaceRole} from '@/types/Workspace'
import {Heading, workspaceRoles} from '@/utils/heading'

/**
 * A edição dos papéis do ambiente, numa janela (decisão do usuário: a página de design só mostra),
 * com Salvar (também do usuário: gravar a cada linha não era legal). A mesma lista da página,
 * editável — ver o `ColoredEntryList`.
 *
 * Grava a lista inteira de uma vez; quem grava, e mostra a recusa — o papel excluído que uma fórmula
 * cita —, é o host. Os papéis vão com a cor em vigor (`coloredRoles`).
 */
@Component({emits: ['closed', 'save'],
  name: 'ontos-roles-dialog',
  components: {'ontos-colored-entry-list': ColoredEntryList}
})
class RolesDialog extends Vue {
  declare $refs: { list: InstanceType<typeof ColoredEntryList> }

  @Prop({type: Array, default: () => []}) readonly roles!: WorkspaceRole[]
  /** O título do ambiente, para o cabeçalho da janela. */
  @Prop({type: String, required: true}) readonly workspaceTitle!: string
  @Prop({type: Boolean, default: false}) readonly saving!: boolean

  /** O gravado, com as cores em vigor: abrir e fechar não é mudança. */
  initial: WorkspaceRole[] = []
  draft: WorkspaceRole[] = []

  /** No created, e não no inicializador do campo — ver o mesmo comentário no `ClassDialog`. */
  created() {
    this.initial = coloredRoles(this.roles)
    this.draft = this.initial
  }

  get heading(): Heading {
    return workspaceRoles({title: this.workspaceTitle})
  }

  /**
   * O Salvar fica ligado com mudança, como nos outros formulários da casa, e é ele que confere: com
   * erro, nada sai, e todos aparecem de uma vez — inclusive o obrigatório de linha não tocada.
   */
  save() {
    if (this.$refs.list.validateModel()) this.$emit('save', this.draft)
  }

  get changed(): boolean {
    return JSON.stringify(this.draft) !== JSON.stringify(this.initial)
  }
}

export default toNative(RolesDialog)
</script>
